import { useRef } from "react";
import { createContext, useContext, useState, useEffect } from "react";
import { useUserStore } from "./useUserStore"; // We rely on user info & token
import SpecificAPI from "../services/SpecificApi";

const PromptsContext = createContext(null);

export const PromptsProvider = ({ children }) => {
  const hasLoadedRef = useRef(false);
  const { isAppUserLoading, appUser } = useUserStore();

  const [prompts, setPrompts] = useState([]);
  const [isPromptsLoading, setIsPromptsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isAppUserLoading) return;

    // 🔁 reset on logout
    if (!appUser) {
      hasLoadedRef.current = false;
      setPrompts([]);
      setIsPromptsLoading(false);
      return;
    }

    // 🛑 fetch once
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;

    const loadPrompts = async () => {
      try {
        setIsPromptsLoading(true);

        let data = [];
        if (appUser.role !== "student") {
          const response = await SpecificAPI.getAllPrompts({});
          data = response || [];
        }

        setPrompts(data);
      } catch (err) {
        console.error("Failed to load prompts:", err);
        setError(err);
      } finally {
        setIsPromptsLoading(false);
      }
    };

    loadPrompts();
  }, [appUser, isAppUserLoading]);

  return (
    <PromptsContext.Provider
      value={{ prompts, isPromptsLoading, error, setPrompts }}
    >
      {children}
    </PromptsContext.Provider>
  );
};

export const usePromptsStore = () => useContext(PromptsContext);
